export default "__VITE_ASSET__CsNoCol3__"